var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,21.38c-5.387-1.611-8.689-7.534-8.689-13.298v-1.571c0-.72.468-1.356,1.155-1.571l6.404-1.998c.736-.23,1.525-.23,2.261,0l6.404,1.998c.687.214,1.155.851,1.155,1.571v1.571c0,5.765-3.081,11.876-8.689,13.298Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.365,14.447l-.377.013c-1.33.046-2.661.046-3.99,0l-.363-.013c-.714-.025-1.296-.583-1.35-1.296h0c-.05-.665-.05-1.333,0-1.999h0c.054-.713.636-1.271,1.35-1.296l.383-.013c1.321-.046,2.644-.046,3.965,0l.382.013c.715.025,1.297.583,1.35,1.297v.007c.05.66.05,1.324,0,1.984v.006c-.054.713-.636,1.272-1.351,1.297Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.165,9.526l.042-1.098c.023-.599.504-1.079,1.104-1.1l.128-.004c.374-.013.748-.013,1.122,0l.128.004c.599.021,1.081.501,1.104,1.1l.042,1.098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d926aeff38940b72c7a55cee1a798eaa.svg";
export { ForwardRef as ReactComponent };